<template>
  <main
    class="terms-page compliance"
    role="main"
    style="background-color:white; padding-top:110px;"
  >
    <div class="container">
      <h2 class="term-page-title">Terms and conditions</h2>
      <ul class="nav nav-tabs" id="termsTabs">
        <li class="nav-item">
          <a class="nav-link active" href="#website_terms" data-toggle="tab">Website</a>
        </li>
        <!-- <li><a href="#subscriber_terms" data-target="subscriber_terms" data-toggle="tab">Subscriber </a></li> -->
        <li class="nav-item">
          <a class="nav-link" href="#updated_subscriber_terms" data-toggle="tab">Subscriber</a>
        </li>
      </ul>
    </div>

    <div class="tab-content container">
      <div class="tab-pane active" id="website_terms">
        <h2 class="compliance-content-tilte">Website terms and conditions</h2>
        <p>These terms and conditions apply to your use of the Website and by accessing this Website, you agree to be bound by the terms and conditions set out below. Before you place an order, if you have any questions relating to these terms and conditions please contact our customer service representatives.</p>
        <ol>
          <li>
            <label>1. Definitions</label><br>
            <ol>
              <li>
                <b>1.1</b>
                <b>"Me and You Mobile"</b> means Me and You Mobile, a division of Comit Technologies (Pty) Ltd, registration number 2011/005082/07.
              </li>
              <li>
                <b>1.2</b>
                <b>"the Website"</b> means www.meandyoumobile.co.za which is owned and operated by Me and You Mobile, a division of Comit Technologies (Pty) Ltd.
              </li>
              <li>
                <b>1.3</b>
                <b>"User"</b> means any person that enters or uses the Website.
              </li>
              <li>
                <b>1.4</b>
                <b>"we"</b>,
                <b>"us"</b> and
                <b>"our"</b> means Me and You Mobile, its affiliates, subsidiaries or its successors-in-title;
              </li>
              <li>
                <b>1.5</b>
                <b>"you"</b> and/or
                <b>"your"</b> means you the User
              </li>
            </ol>
          </li>
          <li>
            <label>2. Electronic Communications</label><br>
            When you visit the Website you consent to receiving communications from us electronically and agree that all agreements, notices, disclosures and other communications sent by us satisfies any legal requirements including, but not limited to, the requirement that such communications should be in writing.
          </li>
          <li>
            <label>3. Disclosures in terms of section 43 of the electronic communications and transactions act, 2002</label><br>

            Any transactions concluded on this website will qualify as "electronic transactions" as defined in terms of the ECT Act and the following information is therefore disclosed in terms of section 43 of the ECT Act:
            <ol>
              <li>
                <b>3.1</b> Street address: 30 Meridian Drive, Umhlanga New Town Centre, Umhlanga, 4320; Postal address: PO Box 1611, Country Club , Mt Edgecombe, 4301.
              </li>
              <li>
                <b>3.2</b> The website address is: http://www.meandyoumobile.co.za.
              </li>
              <li>
                <b>3.3</b> Cooling-off period: If you have entered into an agreement for the supply of goods and / or services through this website, you will have seven (7) days in which to change your mind. After notifying us in writing, we will have 30 days in which to pay you back in full. If goods have already been delivered to you, you will have to return them at your own cost before you get your money back.
              </li>
            </ol>
          </li>
          <li>
            <label>4. Disclaimer</label>
            <ol>
              <li>
                <b>4.1 Whilst every effort has been made by us to ensure the proper performance of this Website, the accuracy of the information, prices and images and their liability of the binary data on this Website, we do not guarantee the availability of services, stock, content and information offered on this website or the accuracy of the information and/or images on this Website.</b>
              </li>
              <li>
                <b>4.2 The Package you have chosen will provide to you the pre-determined In-Bundle Airtime as per your package. When you have exhausted your In-Bundle Airtime, you can continue to enjoy our Services by using your allocated credit limit. Default setting of the credit limit is double your monthly value bundle commitment i.e. should you choose a R100 value bundle, your automatic credit limit is R200 allowing you to spend a total of R300. Should your credit limit be exceeded within a given month, you will be able to increase this credit limit. This can be done in the Manage area of your profile. The credit limit can be increased or decreased, to a minimum value of your bundle on a monthly basis.</b>
              </li>
              <li>
                <b>4.3 Website may contain hyper-links to third party sites. We are not responsible for the content of, or the services offered by those sites. The hyper-link(s) are provided solely for your convenience and should not be construed as an express or implied endorsement by us of the site(s) or the products or services provided therein. You access those sites and use those respective products and services solely at your own risk.</b>
              </li>
              <li>
                <b>4.4 Gift vouchers/cards may not be redeemed for cash or as payment.</b>
              </li>
            </ol>
          </li>
          <li>
            <label>5. Indemnification</label><br>
            <b>You indemnify and holds us harmless against all and any loss, liability, actions, suites, proceedings, costs, demands and damages of all and every kind, (including direct, indirect, special or consequential damages), and whether in an action based on contract, negligence or any other action, arising out of or in connection with the failure or delay in the performance of this Website, or the use of or information and/or images available on this Website, whether due to our negligence or not.</b>
          </li>
          <li>
            <label>6. Variation</label><br>
            <b>These terms and conditions may change from time to time. The obligation therefore is on you to review these terms and conditions at regular intervals.</b>
          </li>
          <li>
            <label>7. General</label>
            <ol>
              <li>
                <b>7.1</b> These terms and conditions will be governed by and construed in accordance with the laws of South Africa, and you shall submit to the jurisdiction of the South African Courts.
              </li>
              <li>
                <b>7.2</b> These terms and conditions are severable, in that if any provision is determined to be illegal or unenforceable by any court of competent jurisdiction, then such provision shall be deemed to have been deleted without affecting the remaining provisions of these terms and conditions.
              </li>
              <li>
                <b>7.3</b> Our failure to exercise any particular rights or provision of these terms and conditions shall not constitute a waiver of such right or provision, unless acknowledged and agreed to by us in writing.
              </li>
              <li>
                <b>7.4</b> These terms and conditions, as varied by us from time to time pursuant to section 5, above constitute the sole agreement between yourself and ourselves.
              </li>
              <li>
                <b>7.5</b> These terms and conditions shall be for the benefit of Me and You Mobile and may be waived by us in our discretion.
              </li>
            </ol>
          </li>
          <li>
            <label>8. Payment options</label><br>            All transactions will be processed in South African Rands (ZAR). We accept credit card and cheque card payments via the website.
          </li>

          <li>
            <label>9. Monitoring</label><br>
            We have the right, but not the obligation, to monitor any activity and content associated with the Website. We may investigate any reported violation of these terms and conditions or complaints and take any action that we deem appropriate (which may include, but is not limited to, issuing warnings, suspending, terminating or attaching conditions to your access and/or removing any materials from the Website).
          </li>
          <li>
            <label>10. Customer and credit card and security policy</label>
            <ol>
              <li>
                <b>10.1</b> Credit card and cheque card transactions will be processed via PayGate (Pty) Ltd who are the approved payment gateway for Standard Bank of South Africa. PayGate uses the strictest form of encryption, namely Secure Socket Layer 3 (SSL3) and no credit card and cheque card details are stored on the Website. Users may go to www.paygate.co.za to view their security certificate and security policy.
              </li>
              <li>
                <b>10.2</b> Your details will be stored by us separately from card details which are entered by the client on PayGate's secure site. For more detail on PayGate refer to www.paygate.co.za.
              </li>
            </ol>
          </li>
          <li>
            <label>11. Contact details</label><br>
            Telephone Number - 0861 333 110
            <br>General Enquiries - support@meandyoumobile.co.za
            <br>WhatsApp - 0616 069 000
          </li>
        </ol>
        <p>
          <b>IMPORTANT: The clauses printed in bold relate to issues which may pose some risk for you or which may limit our liability or which you may not ordinarily expect. Please pay special attention to these clauses. By accessing the website you, in addition to accepting all the above terms and conditions, also specifically signify that you understand the bold clauses and accept them.</b>
        </p>
      </div>

      <div class="tab-pane fade" id="updated_subscriber_terms">
        <h2 class="compliance-content-tilte">Subscriber terms and conditions</h2>
        <ol>
          <li>
            <label>1. Entering into this Agreement</label>
            <ol>
              <li>
                <b>1.1</b> This Agreement records the terms and conditions of the supply of our Services to you. We have defined some of the words which have particular meanings in clause 21 of this Agreement.
              </li>
              <li>
                <b>1.2</b> If there are any words or terms and conditions which you have difficulty understanding, please contact us at support@meandyoumobile.co.za and we will contact and assist you. If you elect not to do this, we will assume that you have no trouble in understanding this Agreement.
              </li>
              <li>
                <b>1.3</b> When you sign this Agreement, which may be done electronically by clicking a tick box on our website, you will be requesting us to give you access to our Services on the terms of this Agreement. If and when we accept your request, we will connect your SIM to our Services. Our acceptance in this way will result in a binding agreement between us.
              </li>
            </ol>
          </li>
          <li>
            <label>2. Duration and Renewal</label>
            <ol>
              <li>
                <b>2.1</b> This Agreement will start when we connect your SIM to our Services and it will then run until terminated by either you or us, save that you cannot terminate this Agreement for a period of 30 days from the start of this Agreement (this excludes the 7 day cooling off period). However, after the aforementioned 30 day period you may cancel this Agreement for any reason and at any time in line with clause 19.
              </li>
            </ol>
          </li>
          <li>
            <label>3. Delivery of the SIM</label>

            <ol>
              <li>
                <b>3.1</b> You must accept delivery of the SIM yourself and provide copies of any documentation that we request, including a copy of your ID and Proof of Address. We may charge you a delivery fee.
              </li>
              <li>
                <b>3.2</b> Any SIM that we provide to you is our property and must be returned on demand. If your SIM is lost, stolen or damaged, you must immediately block the SIM and/or request a replacement SIM. You may have to pay a replacement fee. You will be liable for all charges relating to use of your SIM if it has been lost or stolen until the time that you notify us that you have lost the SIM or that it has been stolen.
              </li>
              <li>
                <b>3.3</b> We will replace any defective SIMS for the duration of this Agreement free of charge, save for delivery charges. Please contact Customer Services if your SIM is defective. If you however request a replacement SIM as a result of it being lost, stolen or damaged, you will be charged a SIM replacement fee as well the delivery fee to get the SIM to you.
              </li>
            </ol>
          </li>
          <li>
            <label>4. Your account with us</label>
            <ol>
              <li>
                <b>4.1</b> You will be required to pay the fixed monthly subscription as selected by you during the process of entering into this Agreement via any one of our nominated platforms including the Website, a mobile site, a social media application and/or direct and retail distribution points.
              </li>
              <li>
                <b>4.2</b> The Package you have chosen will provide to you the pre-determined In-Bundle Airtime as per your package. When you have exhausted your In-Bundle Airtime, you can continue to enjoy our Services by using your allocated credit limit. Default setting of the credit limit is double your monthly value bundle commitment i.e. should you choose a R100 value bundle, your automatic credit limit is R200 allowing you to spend a total of R300. Should your credit limit be exceeded within a given month, you will be able to increase this credit limit. This can be done in the Manage area of your profile. The credit limit can be increased or decreased, to the minimum value of your bundle, on a monthly basis.
              </li>
              <li>
                <b>4.3 Your credit limit, if applicable, is not guaranteed, and should you exceed your allocated credit limit, you will still be liable for the full amount due based on your usage. You accept that we do not guarantee to implement the Monthly Usage Limit and you remain responsible to pay for all Usage Charges spent on your SIM Card over and above the Monthly Usage Limit regardless whether or not we implement the Monthly Usage Limit.</b>
              </li>
              <li>
                <b>4.4 Your monthly In-Bundle Airtime will expire on the last day of every month– i.e. there is no rollover of allocated bundle voice, data or SMS airtime.</b>
              </li>
            </ol>
          </li>
          <li>
            <label>5. Our Services</label>
            <ol>
              <li>
                <b>5.1</b> We will take all reasonable steps within our control to provide to you our Services in terms of this Agreement.
              </li>
              <li>
                <b>5.2</b> Our Services are only available within the range of base stations that make up the Network.
              </li>
              <li>
                <b>5.3 We cannot always guarantee a fault-free Service. The quality and availability can be affected by factors outside of our control, including, amongst other things, the weather, local physical obstructions, other causes of radio interference, weak signal, features and functionality of your particular Device, extraordinary use of the Services by other customers, and faults in infrastructure provided to us.</b>
              </li>
              <li>
                <b>5.4</b> The upgrading, maintenance or other work from time to time on the Network may result in interruptions or unavailability of our Services. Where possible, we will advise you of this in advance.
              </li>
            </ol>
          </li>
          <li>
            <label>6. Use of Services</label>
            <ol>
              <li>
                <b>6.1</b> You may only use the Services for lawful purposes and you warrant that you shall not:
                <ol>
                  <li>
                    <b>6.1.1</b> use the Services to receive or transmit material which is in violation of any law or regulation, which is obscene, threatening, racist, menacing, offensive, defamatory, in breach of confidence, in breach of any intellectual property rights, or otherwise objectionable or unlawful;
                  </li>
                  <li>
                    <b>6.1.2</b> use the Services for the transmission of 'junk mail', 'spam', 'chain letters', or unsolicited mass distribution of SMS;
                  </li>
                  <li>
                    <b>6.1.3</b> other than for your personal and non-commercial use, store on your computer, or print copies of extracts from the Website, and you may not, other than for your personal and non-commercial use, 'mirror' or cache information provided via this website on your own server, or copy, adapt, modify or re-use the text or graphics from the Website without prior written permission from us.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <label>7. Charges</label>
            <ol>
              <li>
                <b>7.1</b> We will charge you for telephone calls you make, SMS's and MMS's you send, data you access and content you download at the rates which appear in Schedule.
              </li>
              <li>
                <b>7.2</b> We will also charge you for connection fees and the other chargeable items as has been agreed to by entering into this Agreement through any one of our nominated platforms including the Website, a mobile site, a social media application and/or direct and retail distribution points.
              </li>
              <li>
                <b>7.3</b> You must pay all taxes, including VAT associated with the Services which we provide to you.
              </li>
              <li>
                <b>7.4</b> The fixed monthly subscription applicable to the Services is charged each month regardless of whether you utilise the Services.
              </li>
              <li>
                <b>7.5</b> Any additional charges not included in your package for items including, but not limited to; Itemised Billing (ITB) will be charged for separately and included in that month’s payment run.
              </li>
              <li>
                <b>7.6 We will require from you a deposit which will be the equivalent of your monthly bundle amount, plus any other fixed monthly charges, applicable under your Package. Upon termination of this Agreement, the deposit amount held will be refunded to you upon request once any amounts owing to us at that point, have been off set.</b>
              </li>
              <li>
                <b>7.7 In your first month of service with the network we will provide you with and you will be charged for a prorated portion of the airtime and data applicable to the Services package you have selected, in accordance with the day of the month you activate your SIM card on the Website. Please note that your SIM card will be activated automatically at the end of the month in which you purchased it.</b>
              </li>
              <li>
                <b>7.8 Below is an example to illustrate the fee structure in clause 7.6 and 7.7</b>
                <ol>
                  <li>
                    <b>7.8.1 You select a R100 Bundle.</b>
                  </li>
                  <li>
                    <b>7.8.2 You will need to pay an upfront deposit of R100.</b>
                  </li>
                  <li>
                    <b>7.8.3 You will need to pay a delivery fee of R80 as well as a SIM and connection fee of R29.</b>
                  </li>
                  <li>
                    <b>7.8.4 You will thus need to pay a total upfront amount of R189 in respect of the deposit, the delivery fee and the SIM and connection fee.</b>
                  </li>
                  <li>
                    <b>7.8.5 If you receive your SIM card and activate it on the Website on the 15th of April we will prorate the airtime value you receive for April by applying the following formula – no. of days remaining in month / total days in month x bundle value.</b>
                  </li>
                  <li>
                    <b>7.8.6 In the above scenario you will receive R50 of your bundle value for the remaining days in April.</b>
                  </li>
                  <li>
                    <b>7.8.7 On the 1st of May, an invoice for your account will be generated which will include your R100 subscription for May + the R50 pro-rated portion that was allocated to you in April. Importantly this invoice is only due for payment on the 1st June.</b>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <label>8. Payment</label>
            <ol>
              <li>
                <b>8.1</b> Charges applicable to your In-Bundle Airtime are billed monthly in advance. The invoice is payable 30 days from the date of invoice.
              </li>
              <li>
                <b>8.2</b> Out-of-Bundle Airtime usage will be billed for and paid in arrears.
              </li>
              <li>
                <b>8.3</b> The use by you of the credit limit (if applicable) must be paid monthly in arrears.
              </li>
              <li>
                <b>8.4</b> Each individual customer will have access, via the Website; to an electronic copy of your invoice and or statement which will record, amongst other pertinent data, the monthly subscription applicable to your In-Bundle Airtime and the amount payable by you by reason of your use of your credit facility (if applicable).
              </li>
              <li>
                <b>8.5</b> You have 30 calendar days from the date of each invoice that we issue to you to query any amount or detail on that invoice. If you do not raise the query within 30 calendar days then it is assumed you accept the invoice as correct.
              </li>
            </ol>
          </li>
          <li>
            <label>9. Payment Method</label>
            <ol>
              <li>
                <b>9.1</b> You will be debited the full amount owing on your account from an accepted credit card or cheque card. If your credit card or cheque card payment fails me&amp;you mobile reserves the right to debit the card again after the failed debit.
              </li>
              <li>
                <b>9.2</b> For your and our convenience, your credit card or cheque card details will be retrieved, in an encrypted format, monthly from our secure payment gateway and payment will be effected automatically on the last working day (unless otherwise notified) of every month. Please note that we do not store any of your credit card or cheque card details, unless you have asked us to assist you with entering into this Agreement and you have provided us with your credit or cheque card details during a telephone conversation. While we will take reasonable steps to keep your credit and cheque card details secure, where you provide us with those details during a telephone conversation, we will not be liable for any unauthorised use of those details.
              </li>
              <li>
                <b>9.3</b> If your credit card or cheque card details have changed or your credit card or cheque card has expired, please contact our Customer Care to load your new details or you can load those new details on the Website or you can make payment directly via the Website.
              </li>
            </ol>
          </li>
          <li>
            <label>10. Changes in price</label>
            <ol>
              <li>
                <b>10.1</b> We may change the prices which you pay for Services at any time.
              </li>
              <li>
                <b>10.2</b> If we change our prices, we will give you at least 30 days' notice on the Website.
              </li>
            </ol>
          </li>
          <li>
            <label>11. Failure to pay your account</label>
            <ol>
              <li>
                <b>11.1</b> If you do not pay your account in full and on time you will be in breach of this Agreement and we can stop you using some or all of our Services, and can implement the provisions of clause 12.
              </li>
            </ol>
          </li>
          <li>
            <label>12. Breach</label>
            <ol>
              <li>
                <b>12.1</b> In the event that you breach a provision of this Agreement and remain in breach after 20 days' notice to remedy the breach, we have the right to:
                <ol>
                  <li>
                    <b>12.1.1</b> enforce this Agreement; and/or
                  </li>
                  <li>
                    <b>12.1.2</b> terminate this Agreement; and in either case
                  </li>
                  <li>
                    <b>12.1.3</b> claim from you damages which we suffer.
                  </li>
                  <li>
                    <b>12.1.3</b> in the event that we must launch legal proceedings against you as a result of your breach, you will be liable for the charges including tracing agent fees and legal fees on an attorney and client scale.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <label>13. Downward Migration and Upward Migration</label>
            <ol>
              <li>
                <b>13.1</b> You may at any time, except for the last day of the month; downward migrate from your Package to a less costly Package. The downward migration however will only come in to effect in the month following your migration request.
              </li>
              <li>
                <b>13.2</b> The result of a downward migration is that you will be charged a lower subscription price for your In-Bundle Airtime (which will be reduced or limited accordingly).
              </li>
              <li>
                <b>13.3</b> Downward migrations will be limited to the Packages which we offer from time to time but you will not be able to downward migrate from a Package which is at the time the least costly or which offers the least In-Bundle Airtime.
              </li>
              <li>
                <b>13.4</b> You may downward migrate as many times as you like during the period that this Agreement is in force, subject to the provisions of Clause 13.3 above.
              </li>
              <li>
                <b>13.5</b> At any stage following the commencement of this Agreement, except for the last day of the month; you may (based on qualifying criteria) upward migrate from your Package to a more costly Package. If you decide to do this, the upward migration will only come in to effect in the month following your migration request and once your credit card or cheque card has been successfully debited for that following month’s subscription.
              </li>
              <li>
                <b>13.6</b> The result of an upward migration is that you will be charged a higher subscription price for your In-Bundle Airtime (which will be increased accordingly),
              </li>
              <li>
                <b>13.7</b> Upward migrations will be limited to the Packages which we offer from time to time but you will not be able to upward migrate from a Package which is at the time the most costly or which offers the most In-Bundle Airtime.
              </li>
              <li>
                <b>13.8</b> We reserve the right to exclude specials run from time to time from the Packages you are able to migrate to.
              </li>
            </ol>
          </li>
          <li>
            <label>14. International Roaming</label>
            <ol>
              <li>
                <b>14.1</b> If you use our Services whilst outside of South Africa, you will be considered to be roaming internationally. If you roam internationally additional terms and conditions apply. These terms and conditions can be found on our Website and can also be obtained from Customer Services. In order to activate your international roaming, contact Customer Services or visit our website before leaving the country
              </li>
              <li>
                <b>14.2</b> When you roam internationally, you will be charged at higher rates for that usage (these rates can be very high). Be aware that the rates are based on what we are charged by Network Operators outside South Africa. You will also be billed for receiving calls. These Network Operators may bill us some time after your return (up to 90 days maximum).
                <b>You will be required to produce a R1000 upfront payment before international roaming is enabled on your SIM.</b> Once we have received the final bill from the international network, we will reconcile your account, and any funds remaining will be offset against your future invoices until the surplus is depleted.
              </li>
            </ol>
          </li>
          <li>
            <label>15. International Dialling</label>
            <ol>
              <li>
                <b>15.1</b> International dialling will be set to active status on your account once your SIM has been activated on the Network. This will allow you to make calls to countries outside of South Africa.
              </li>
              <li>
                <b>15.2</b> Calls to countries outside of South Africa are charged at higher rates. These rates, by country, can be found on the website under the FAQ section.
              </li>
              <li>
                <b>15.3</b> Calls to countries outside of South Africa are billed separately, outside of your In-Bundle Airtime, i.e. your In-Bundle Airtime will not be depleted, but instead you will be charged the applicable rate separately, for the respective country.
              </li>
            </ol>
          </li>
          <li>
            <label>16. Porting</label>
            <ol>
              <li>
                <b>16.1</b> Porting-in into the Network, from a non-me&amp;you mobile number, is simple and full details on the process can be found on our Website in the FAQ’s. Alternatively, you can call through to Customer Services and they will provide you with the necessary information.
              </li>
              <li>
                <b>16.2</b> For full details on what is required to Port-out, please contact Customer Services.
              </li>
              <li>
                <b>16.3</b> When you Port-out to another Network Operator we will send you your final account which must be settled in full immediately. This account will include all outstanding amounts.
              </li>
            </ol>
          </li>
          <li>
            <label>17. Information and disclosure</label>
            <ol>
              <li>
                <b>17.1</b> In entering into this Agreement and providing the Services, we will come into possession of information pertaining to you. Insofar as it is permissible in law, we will hold that information as our own and will be entitled to disclose it to such third parties as we deem appropriate.
              </li>
              <li>
                <b>17.2</b> You warrant and guarantee that all information supplied to us is true and correct.
              </li>
              <li>
                <b>17.3</b> Should your address, or any other information which you have given to us, change you must inform us of the change immediately.
              </li>
            </ol>
          </li>
          <li>
            <label>18. Indemnity and waiver</label>
            <ol>
              <li>
                <b>18.1 You indemnify us against any loss or damage which any person (including ourselves) may suffer arising directly or indirectly from you breaching your obligations under this Agreement.</b>
              </li>
              <li>
                <b>18.2 We rely on third party providers to supply our Service. You agree not to hold us or any of our third party providers (to the extent permitted by law) liable for damages, losses, costs or expenses, whether direct, indirect or consequential arising from or in connection with any act, omission, neglect or default of a third party provider, or us where this is a result of the third party provider's action or omission, neglect or default.</b>
              </li>
              <li>
                <b>18.3 We are not liable for any failure or delay in providing any Services, in correcting any fault in any Services, failure or incorrect operation of any Service, or any other delay or default in performance under this Agreement if it is caused by an event reasonably beyond our control, including but not limited to civil insurrection, interruption in electrical supply, accident, act of God, industrial action, a direction of any sort by ICASA, delay, failure or default by any other supplier or Network Operator.</b>
              </li>
            </ol>
          </li>
          <li>
            <label>19. Termination</label>
            <ol>
              <li>
                <b>19.1</b> You or we may, terminate this Agreement at any time, for any reason.
              </li>
              <li>
                <b>19.2</b> If you or we terminate this Agreement then we shall be entitled to recover from you that portion of your bill and any unbilled usage which remains outstanding. Such amounts owing will be set-off against your deposit in clause 7.6 and the balance will be debited to your credit card or cheque card. If the deposit in clause 7.6, or part thereof, remains standing to your credit after the aforementioned set-off, such amount will be refunded to you, upon request by calling Customer Services, save that you will forfeit the deposit entirely if you terminate this Agreement after seven days and within the first three months of this Agreement
              </li>
            </ol>
          </li>
          <li>
            <label>20. General</label>
            <ol>
              <li>
                <b>20.1</b> We reserve the right to change the terms and conditions in this Agreement with 30 days' notice to you, subject to clause 10.2.
              </li>
              <li>
                <b>20.2</b> Any concession or extra time we allow you doesn't affect our rights under this Agreement.
              </li>
              <li>
                <b>20.3</b> You agree that this Agreement will be interpreted and governed according to the laws of South Africa.
              </li>
              <li>
                <b>20.4</b> You choose the personal address for yourself set forth in the Schedule where you will accept service of all notices and court process from us.
              </li>
              <li>
                <b>20.5</b> Notwithstanding anything to the contrary, a written notice actually received by you will be adequate written notice.
              </li>
              <li>
                <b>20.6</b> You acknowledge that in entering into this Agreement, you have not relied on any promises, representations or other statements made by us or on our behalf.
              </li>
              <li>
                <b>20.7</b> You release us and each of our officers, agents and advisors from all claims, actions, and demands of any kind (including carelessness) arising from our relationship in terms of this Agreement and from discussions leading to it.
              </li>
              <li>
                <b>20.8</b> In order to enjoy the use of our Services it is a requirement that you acknowledge and accept that you will have to register with us in terms of RICA.
              </li>
              <li>
                <b>20.9</b> If any term of this Agreement is found to be invalid or unenforceable, that term will be removed and the invalid or unenforceable term will not affect the validity of the remainder of this Agreement, which will remain effective.
              </li>
              <li>
                <b>20.10</b> You cannot transfer to anyone else, without our consent your SIM. Nor may you, transfer, cede or assign any of your rights and responsibilities under this Agreement. We can transfer, cede or assign any of our rights and obligations at any time.
              </li>
              <li>
                <b>20.11</b> If we have concluded this Agreement with you through direct marketing you may terminate the Agreement, in writing, within 5 Business Days' after the later of the date on which the Agreement was concluded or on which the SIM was delivered to you. You will be liable for reasonable costs incurred by us and any damages to the SIM card and packaging
              </li>
            </ol>
          </li>
           <li>
            <label>21. Spot</label>
            <ol>
              <li>
                <b>21.1</b> You may only qualify for 1 freemium deal per customer &amp; will be liable for all costs for additional SIMs ordered. 
              </li>
              <li>
                <b>21.2</b> Your freemium benefit of 230mb and 5 mins will be loaded every 7 days provided your minimum spot top up of R200 is achieved in the prior calendar month.
              </li>
              <li>
                <b>21.3</b> No refund will be granted if your sim is not delivered after 3 successful attempts.
              </li>
              <li>
                <b>21.4</b> Additional bundles will be used prior to the free 230mb + 5min bundles.
              </li>
            </ol>
          </li>
          <li>
            <label>22. Definitions</label>
            <ol>
              <li>
                <b>21.1</b> "this Agreement" means this agreement and the Schedule, once signed by you and accepted by us, the acceptance being in a manner which we deem appropriate from time to time, and the Website terms and conditions which can be accessed
                <a href="#terms-and-conditions/website_terms" class="_jsWebsite_terms">here</a>;
              </li>
              <li>
                <b>22.2</b> "Airtime" means cellular airtime, messaging platforms, data bundling and value added services;
              </li>
              <li>
                <b>22.3</b> "Business Days" means all days, excluding Saturdays, Sundays and public holidays. When calculating business days, one must exclude the first day on which the event occurs and include the last day;
              </li>
              <li>
                <b>22.4</b> "Customer Services" means our Customer Services department which you can contact on 0861 333 110 at normal charges (or 135 free from your me&amp;you mobile SIM) or via email;
              </li>
              <li>
                <b>22.5</b> "Device" means any one or more, as the context requires, of a cellular telephone, a SIM and/or any paraphernalia which you receive from us;
              </li>
              <li>
                <b>22.6</b> "In-Bundle Airtime" means the Airtime allocated to you under your Package.
              </li>
              <li>
                <b>22.7</b> "Maximum Usage Limit" means the monthly limit set for you, to regulate your spending;
              </li>
              <li>
                <b>22.8</b> "Network Operator" means any person licensed to operate an electronic communications network using cellular technology, in South Africa;
              </li>
              <li>
                <b>22.9</b> "Network" means the digital mobile device network and/or the wireless platform for internet services in South Africa that allows you to receive or use our Services;
              </li>
              <li>
                <b>22.10</b> "Out-of-Bundle Airtime" means any Airtime which is not In-Bundle Airtime;
              </li>
              <li>
                <b>22.11</b> "Package" means the combination of the components of Airtime which you choose, and the pricing applicable thereto;
              </li>
              <li>
                <b>22.12</b> "Port" or "Porting" means when we transfer your phone number from another Network Operator to us or from us to another Network Operator, if you have a valid Agreement with us;
              </li>
              <li>
                <b>22.13</b> "Port-out" means when you leave us and take your phone number with you;
              </li>
              <li>
                <b>22.14</b> "RICA" means the Regulation of Interception of Communications and Provision of Communication Related Information Act 70 of 2000, as amended;
              </li>
              <li>
                <b>22.15</b> “Schedule” means any schedule of prices, contract and renewal periods, Services packages and ancillary information which you select on the Website, a mobile site, social media application,
              </li>
              <li>
                <b>22.16</b> "Services" means the digital electronic communications service, internet access services and other electronic communications services which we procure for you via the Network from time to time;
              </li>
              <li>
                <b>22.17</b> "SIM" means the SIM card or Subscriber Identity Module card containing your phone number and which is programmed to allow you access to our Services over the Network;
              </li>
              <li>
                <b>22.18</b> “Usage Charges” the usage charges pertaining to your utilisation of Airtime;
              </li>
              <li>
                <b>22.19</b> "we", "us" and "our" means Me and You Mobile, a division of Comit Technologies (Pty) Ltd, registration number 2011/005082/07, its agents, employees, affiliates, subsidiaries or its successors-in-title;
              </li>
              <li>
                <b>22.20</b> "Website" means www.meandyoumobile.co.za and includes our online store; and
              </li>
              <li>
                <b>22.21</b> "you" and/or "your" means you the customer who applies for and receives our Services.
              </li>
            </ol>
          </li>
          <li>
            <label>23. Contact details</label><br>
            Email: support@meandyoumobile.co.za
            <br>Phone: 0861 333&nbsp;110
            <br>Whatsapp: 061&nbsp;606 9000
          </li>
        </ol>
        <p>
          <b>IMPORTANT: The clauses printed in bold relate to issues which may pose some risk for you or which may limit our liability or which you may not ordinarily expect. Please pay special attention to these clauses. By entering into the Agreement you, in addition to accepting all the terms of the Agreement, also specifically signify that you understand the bold clauses and accept them.</b>
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "terms",
  components: {}
};
</script>